import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "root-index" };
const _hoisted_2 = { class: "root-body" };
import { computed } from 'vue';
import Gnb from '@/views/Gnb.vue';
import Menu from '@/views/Menu.vue';
import DialogOrderInfo from '@/components/Common/DialogOrderInfo.vue';
import HeaderControllerWrapper from '@/views/HeaderControllerWrapper.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MainLayout',
    setup(__props) {
        const containerTemplateClass = computed(() => ({
            'root-container-template': true,
        }));
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" Header "),
                _createVNode(Gnb, { class: "root-header" }),
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Menu "),
                    _createVNode(Menu, { class: "root-menu" }),
                    _createCommentVNode(" Container "),
                    _createElementVNode("div", {
                        class: _normalizeClass(["root-container", containerTemplateClass.value])
                    }, [
                        _createCommentVNode(" header section "),
                        _createVNode(HeaderControllerWrapper),
                        _createCommentVNode(" Router 2 Depth :: page content section "),
                        _createVNode(_component_router_view)
                    ], 2 /* CLASS */)
                ]),
                _createCommentVNode(" [모달] 주문 상세 "),
                _createVNode(DialogOrderInfo)
            ]));
        };
    }
});
